import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Table, TableHeader, TableHeading, TableBody, TableRow, TableCell } from '@bibliocommons/table';
import TextField from '@bibliocommons/text-field';

import ContextMenu from 'app/components/admin/browse/shared/ContextMenu';
import { VALIDATION_ERROR_MESSAGE } from 'app/constants/admin/browse/home';
import { catalogTitlesSectionShape, catalogTitlesSectionValidationShape } from 'app/shapes/admin/browse/home';
import EditorHasAlternativeBackgroundToggle from './shared/EditorHasAlternativeBackgroundToggle';
import EditorUrl from './shared/EditorUrl';
import TableWrapper from './shared/TableWrapper';

import './SectionEditorCatalogTitles.scss';

const SectionEditorCatalogTitles = ({ onChange, section: catalogTitlesSection, validation }) => {
  const { hasAlternativeBackground, heading, searchUrl, sectionId } = catalogTitlesSection;
  const { errorByAttribute } = validation;

  const [isEditingUrl, setIsEditingUrl] = useState(!searchUrl);

  const handleHasAlternativeBackgroundChange = newHasAlternativeBackground => {
    onChange({
      ...catalogTitlesSection,
      hasAlternativeBackground: newHasAlternativeBackground
    });
  };

  const handleHeadingChange = newHeading => {
    onChange({
      ...catalogTitlesSection,
      heading: newHeading
    });
  };

  const handleUrlEditCancel = () => {
    setIsEditingUrl(false);
  };

  const handleUrlEditClick = () => {
    setIsEditingUrl(true);
  };

  const handleUrlSave = newUrl => {
    onChange({
      ...catalogTitlesSection,
      searchUrl: newUrl
    });

    setIsEditingUrl(false);
  };

  const editorHasAlternativeBackgroundToggleKey = `${sectionId}_EditorHasAlternativeBackgroundToggle`;
  const headingInputId = `${sectionId}_HeadingInput`;

  return (
    <div className="cp-admin-browse-home-section-editor-catalog-titles">
      <div className="heading-field-wrapper">
        <TextField
          errorMessage={errorByAttribute.heading}
          id={headingInputId}
          label="Heading"
          onChange={handleHeadingChange}
          type="text"
          value={heading}
        />
      </div>

      <EditorHasAlternativeBackgroundToggle
        className="toggle-alt-background"
        key={editorHasAlternativeBackgroundToggleKey}
        onChange={handleHasAlternativeBackgroundChange}
        value={hasAlternativeBackground}
      />

      <TableWrapper>
        <Table>
          <TableHeader>
            <TableHeading colSpan={2}>Catalog search URL</TableHeading>
          </TableHeader>
          <TableBody>
            <TableRow>
              {isEditingUrl ? (
                <TableCell colSpan={2}>
                  <EditorUrl
                    errorMessage={errorByAttribute.searchUrl}
                    invalidUrlMessage={VALIDATION_ERROR_MESSAGE.INVALID_CATALOG_SEARCH_URL}
                    label="Catalog search URL"
                    onCancel={handleUrlEditCancel}
                    onChange={handleUrlSave}
                    url={searchUrl}
                  />
                </TableCell>
              ) : (
                <>
                  <TableCell>{searchUrl}</TableCell>
                  <TableCell className="cell-context-menu">
                    <ContextMenu onEditClick={handleUrlEditClick} />
                  </TableCell>
                </>
              )}
            </TableRow>
          </TableBody>
        </Table>
      </TableWrapper>
    </div>
  );
};

SectionEditorCatalogTitles.defaultProps = {
  validation: {
    isValid: true,
    errorByAttribute: {
      heading: '',
      searchUrl: ''
    }
  }
};

SectionEditorCatalogTitles.propTypes = {
  onChange: PropTypes.func.isRequired,
  section: catalogTitlesSectionShape.isRequired,
  validation: catalogTitlesSectionValidationShape
};

export default SectionEditorCatalogTitles;
